"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TitleBar = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _Control = require("../Control");

var _useTheme = require("../hooks/useTheme");

var _stylingConstants = require("../styling/stylingConstants");

var _useResponsiveMode = require("../styling/useResponsiveMode");

var _TitleBarIcon = require("./TitleBarIcon");

var getClassNames = (0, _react.classNamesFunction)();
/**
 * A responsive horizontal bar with standard styling, supporting an icon,
 * multiple labels, and multiple trailing action/icon buttons. Is used to
 * implement the header of other higher order components (e.g. `Collapsible`).
 * Lets us keep the same look-and-feel with headers across the app.
 *
 * Any `TitleBarLabel` or `TitleBarAction` elements used as immediate children
 * will be placed in the appropriate title bar areas. Children which are not
 * labels or actions will be wrapped in a label automatically.
 */

var TitleBarBase = function TitleBarBase(_ref) {
  var ariaLabel = _ref.ariaLabel,
      ariaExpanded = _ref.ariaExpanded,
      children = _ref.children,
      actions = _ref.actions,
      className = _ref.className,
      iconProps = _ref.iconProps,
      labelsClassName = _ref.labelsClassName,
      onClick = _ref.onClick,
      responsiveMode = _ref.responsiveMode,
      _ref$showBorder = _ref.showBorder,
      showBorder = _ref$showBorder === void 0 ? true : _ref$showBorder,
      styles = _ref.styles,
      tabIndex = _ref.tabIndex,
      role = _ref.role;
  var theme = (0, _useTheme.useTheme)();
  var currentResponsiveMode = (0, _useResponsiveMode.useResponsiveMode)();
  var vertical = !!responsiveMode && currentResponsiveMode <= responsiveMode;
  var classes = getClassNames(styles, {
    theme: theme,
    vertical: vertical,
    showBorder: showBorder
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Control.Control, {
    className: (0, _react.css)(className, 'ms-TitleBar'),
    onClick: onClick,
    "aria-label": ariaLabel,
    "aria-expanded": ariaExpanded,
    styles: classes.subComponentStyles.control,
    tabIndex: tabIndex,
    role: role,
    children: [iconProps && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TitleBarIcon.TitleBarIcon, (0, _objectSpread2.default)({}, iconProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _react.css)('ms-TitleBar--labels', labelsClassName, classes.labels),
      children: children
    }), actions]
  });
};

var TitleBar = (0, _react.styled)(TitleBarBase, function (_ref2) {
  var palette = _ref2.theme.palette,
      vertical = _ref2.vertical,
      showBorder = _ref2.showBorder;
  return {
    labels: {
      display: 'flex',
      flexDirection: vertical ? 'column' : 'row',
      justifyContent: vertical ? 'center' : undefined,
      flex: 'auto'
    },
    subComponentStyles: {
      control: {
        root: [{
          display: 'flex',
          flexDirection: 'row',
          flex: '0 0 auto',
          minHeight: _stylingConstants.gridUnit * 6,
          background: palette.white
        }, showBorder && {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: palette.neutralLight
        }]
      }
    }
  };
});
exports.TitleBar = TitleBar;